import React from 'react'
import RankingItem from '@/components/Ranking/RankingItem'

const General = ({ ranking }) => {
  return (
    <div className="mx-auto container sm:px-4 px-2 xl:px-20 relative">
      {ranking.map((row, index) => {
        return (
          <RankingItem
            key={index}
            complex={true}
            data={row}
            position={index + 1}
          />
        )
      })}
    </div>
  )
}

export default General
